import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchOtoplasty,
  fetchOtoplastyBanner,
} from "../../api/SurgicalDomainApi";

const Otoplasty = () => {
  const { setLoading } = useLoader();
  const [otoplastyBanner, setOtoplastyBanner] = useState<IBannerData[]>([]);
  const [otoplastyData, setOtoplastyData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchOtoplastyBanner(),
      fetchOtoplasty(),
      fetchConsentLetters(),
    ])
      .then(([otoplastyBannerData, otoplastyData, consentLettersData]) => {
        setOtoplastyBanner(otoplastyBannerData);
        setOtoplastyData(otoplastyData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={otoplastyBanner}
        page={"Mentoplasty"}
      />
      <SurgicalDomainsDescription descriptionData={otoplastyData} consentLetters={consentLetters} surgicalName='Otoplasty'/>
    </>
  );
};

export default Otoplasty;
